<template>
  <md-button
    :class="`${className}`"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </md-button>
</template>
<script>
export default {
  name: 'GenericButton',
  props: {
    variation: {
      required: false,
      default: ''
    },
    icon: {
      required: false,
      default: false,
      type: Boolean
    },
    transparent: {
      required: false,
      default: false,
      type: Boolean
    },
    fab: {
      required: false,
      default: false,
      type: Boolean
    },
    textInherit: {
      required: false,
      default: false,
      type: Boolean
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    }
  },
  computed: {
    className() {
      return `
        c-generic-btn
        ${this.variation && 'btn-' + this.variation}
        ${this.icon ? 'md-icon-button' : ''}
        ${this.transparent ? '' : 'md-raised'}
        ${this.fab ? 'md-fab' : ''}
        ${this.textInherit ? 'text-inherit' : ''}
      `.trim();
    }
  }
};
</script>

<style lang="scss">
.btn-transparent { background: transparent !important; }
.btn-red         { background: var(--brand-600) !important; }
.btn-green       { background: #079455 !important; }
.btn-blue        { background: #1570ef !important; }
.btn-grey-light  { background: var(--bg-subtle) !important; }
.btn-orange      { background: #f79009 !important; }

.md-button {
  margin: 0 !important;
  cursor: pointer;

  // text buttons: flat, rounded, sentence case (GenericButton only)
  &.c-generic-btn:not(.md-icon-button):not(.md-fab) {
    height: 38px;
    min-width: 0;
    padding: 0 4px;
    border-radius: var(--radius-md);
    font-family: var(--font-sans);
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    text-transform: none;
    transition: background-color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;

    .md-ripple {
      padding: 0 12px;
    }

    // solid colour variations
    &.btn-red,
    &.btn-green,
    &.btn-blue,
    &.btn-orange {
      color: #fff !important;
      box-shadow: var(--shadow-xs) !important;

      &:hover {
        filter: brightness(0.92);
      }

      label {
        color: inherit;
        cursor: pointer;
      }
    }

    &.btn-grey-light {
      color: var(--text-primary) !important;
    }

    // transparent without a colour = ghost
    &:not(.md-raised):not([class*='btn-']) {
      color: var(--text-secondary) !important;

      &:hover {
        background-color: var(--bg-hover) !important;
        color: var(--text-primary) !important;
      }
    }
  }

  // raised default / grey = secondary (outlined)
  &.c-generic-btn.md-raised:not(.md-icon-button):not(.md-fab) {
    &:not([class*='btn-']),
    &.btn-grey {
      background: var(--bg-surface) !important;
      color: var(--text-primary) !important;
      box-shadow: inset 0 0 0 1px var(--border-strong), var(--shadow-xs) !important;

      &:hover {
        background: var(--bg-subtle) !important;
      }
    }
  }

  // icon buttons: compact rounded ghost buttons
  &.md-icon-button {
    width: 32px;
    min-width: 32px;
    height: 32px;
    border-radius: var(--radius-md);
    transition: background-color var(--duration-fast) ease;

    &:not([disabled]):hover {
      background-color: var(--bg-hover) !important;
    }

    .md-ripple {
      border-radius: var(--radius-md);
    }

    .md-icon {
      color: var(--text-secondary);
    }
  }

  &.text-inherit {
    &,
    .md-icon-font {
      color: inherit !important;
      text-transform: inherit !important;
    }
  }

  &[disabled] {
    opacity: 0.4 !important;
    cursor: default;
    pointer-events: none;
  }
}
</style>
